<template lang="pug">
  router-link.white-fone(
  :class="{'top': top}"
  :to="{name: 'jobseekerCV', params: {lang: getLanguage, id: cv.id, previous: $route}}")
    .columns.is-multiline
      .column.is-one-quarter
        p.title {{ `${cv.first_name} ${cv.last_name}` }}
          span.mdi.mdi-verified.icon-shield(v-if="closed && !inactive.HIDE_INACTIVE")
        p.type(v-if="cv.has_profession && cv.profession") {{ cv.profession.name }}
        .block.cv-info
          .only-grid
            span {{ gettext('Type of employment:') }}
            p(v-if="cv.is_trainee")
              span.bold {{ gettext('Trainee') }}
            p(v-else)
              span.bold(v-if="cv.type === CONSTANTS.TYPE_PERMANENT_WORK && cv.is_skilled") {{ gettext('Skilled worker') }}
              span.bold(v-if="cv.type === CONSTANTS.TYPE_PERMANENT_WORK && !cv.is_skilled") {{ gettext('Unskilled worker') }}
              span.bold(v-if="cv.type === CONSTANTS.TYPE_SEASONAL_WORK && cv.is_skilled") {{ gettext('Seasonal/Skilled worker') }}
              span.bold(v-if="cv.type === CONSTANTS.TYPE_SEASONAL_WORK && !cv.is_skilled") {{ gettext('Seasonal/Unskilled worker') }}
          div(v-if="cv.age")
            p
              span {{ gettext('Age') }}:&nbsp;
              span {{ cv.age }}
          div(v-if="cv.gender")
            p
              span {{ gettext('Gender') }}:&nbsp;
              span(v-if="cv.gender === 10") {{gettext('Male') }}
              span(v-if="cv.gender === 20") {{ gettext('Female') }}
          div
            p
              span {{ gettext('Original nationality') }}:&nbsp;
              span {{ cv.jobseeker.country.name }}
          div
            p
              span {{ gettext('EU Citizenship') }}:&nbsp;
              span {{ cv.eu_citizenship ? gettext('Yes') : gettext('No') }}
          div
            p
              span {{ gettext('Languages') }}:&nbsp;
              span {{cv.languages.slice(0, 3).map(x => x.language.name + ' / ' + x.level.name).join(', ')}} {{ cv.languages.length > 3 ? gettext('And more...'): '' }}
      .column.is-half
        h3.preview-label.hide-on-mobile {{ gettext('Type of employment') }}:
        .employment-types.hide-on-mobile(v-if="cv.is_trainee")
          span.tag.is-light
            strong {{ gettext('Trainee') }}
        .employment-types.hide-on-mobile(v-else)
          span.tag.is-light(v-if="cv.type === CONSTANTS.TYPE_PERMANENT_WORK && cv.is_skilled")
            strong {{ gettext('Skilled worker') }}
          span.tag.is-light(v-if="cv.type === CONSTANTS.TYPE_PERMANENT_WORK && !cv.is_skilled")
            strong {{ gettext('Unskilled worker') }}
          span.tag.is-light(v-if="cv.type === CONSTANTS.TYPE_SEASONAL_WORK && cv.is_skilled")
            strong {{ gettext('Seasonal/Skilled worker') }}
          span.tag.is-light(v-if="cv.type === CONSTANTS.TYPE_SEASONAL_WORK && !cv.is_skilled")
            strong {{ gettext('Seasonal/Unskilled worker') }}

        h3.preview-label {{ gettext('Work experiences') }}:
        ul(v-if="cv.work_experiences.length")
          li(v-for="(exp, index) in workExpiriences")
            p
              span {{ gettext('Country') }}:
              span {{ (exp.country || {}).name }}
            p(v-if="exp.profession")
              span {{ gettext('Profession') }}:
              span {{ exp.profession.name }}
            p(v-else)
              span {{ gettext('Profession') }}:
              span {{ exp.position }}
            p
              span {{ gettext('Period') }}:
              span {{ exp.period_time | experience }}
          li(v-if="cv.work_experiences.length > 5")
            p {{ gettext('And more...') }}
        div(v-else): p {{ gettext('Another experience') }}

      .column.is-one-quarter.relative
        .item-id
          p(v-if="cv.is_partner && cv.partner_code")
            | {{ cv.partner_code }}
          p
            span {{ gettext('ID') }}:&nbsp;
            | {{ cv.id }}
        .img-wrap(v-if="(cv.image_urls || {}).mid" :style="{ 'background-image': 'url(' + (cv.image_urls || {}).mid + ')'}")
          .partner(v-if="cv.is_partner") P
        .img-wrap(v-else)
          .partner(v-if="cv.is_partner") P
          .small
          .btn-get
            span(v-if="top") {{ gettext('Top') }}
        p.posted {{ gettext('Posted') }}: {{ cv.updated_dt | format }}
        button.main-btn.col-white.bg-red.worker-details {{ gettext('See more') }}

</template>

<script>
import { mapGetters } from 'vuex'
import { gettext, ngettext } from '@/services/TranslateHandler'
const moment = require('moment')
const inactive = require('@/constants.json')
const CONSTANTS = require('@/constants.json')

export default {
  name: 'WorkerPreview',
  data () {
    return {
      inactive: inactive,
      CONSTANTS: CONSTANTS
    }
  },
  props: {
    closed: {
      default: true
    },
    top: {
      default: false
    },
    cv: {
      default: () => {
        return {}
      }
    }
  },
  filters: {
    format: function (val) {
      return moment(val).format('DD.MM.YYYY')
    },
    reverse: function (val) {
      return val.reverse()
    },
    experience: function (val) {
      let result = ''
      let y = Math.floor(val / 12)
      let m = (val % 12)
      if (y) result = `${y} ${ngettext('year', 'years', y)}`
      if (y && m) result += ` ${gettext('and')} `
      if (m) result += `${m} ${ngettext('month', 'months', m)}`
      if (result) result += `. `
      return result
    }
  },
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    workExpiriences: function () {
      return this.cv.work_experiences.slice(0, 3)
    }
  }
}
</script>

<style lang='scss' scoped>
  .item-id {
    display: flex;
    justify-content: center;
    flex-wrap: nowrap;
    p {
      color: #363636;
      white-space: nowrap;
      &:nth-child(2) {
        margin-left: 15px;
      }
      span {
        font-weight: bold;
      }
    }
  }
  .content.worker-preview.view-list {
    .only-grid {
      display: none;
    }
    .item-id {
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
      margin: -24px auto;
      z-index: 10;
      p{
        white-space: nowrap;
        &:first-child {
          margin-right: 15px;
        }
      }
    }
    .bg-red.worker-details {
      width: 146px;
    }
  }
  h3 {
    &.preview-label {
      font-size: 18px;
      font-weight: 300;
      margin: 0 0 10px 0;
    }
  }
  .employment-types {
    margin: 0 0 10px 0;
    .is-light {
      margin: 3px 6px 3px 0;
    }
  }
  .img-wrap {
    background-image: url("/webapp/images/workers/worker-default-bix.png");
    background-size: contain;
    background-repeat: no-repeat;
    width: 146px;
    height: 146px;
  }

  .cv-info {
    color: #000;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.14px;
    word-wrap: break-word;
    word-break: break-word;
    div {
      margin-bottom: .5rem;
      .lang-title{
        margin-bottom: 0.2rem;
        display: block;
      }
      p {
        font-weight: bold;
        span{
          font-weight: normal;
          word-wrap: normal;
          word-break: normal;
          &:last-child{
            font-weight: bold;
          }
        }
      }
      &.break {
        display: flex;
        flex-direction: column;
      }
    }
    .bold {
      font-weight: bold;
    }
  }
  @media screen and (max-width: 480px) {
    .hide-on-mobile {
      display: none;
    }
    .content.worker-preview.view-list {
      .only-grid {
        display: block;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/search/workers/parts/worker-preview/index.vue